const Default = {
};

export class JCVideoSlider {

	constructor(params)
	{
		this.settings = Object.assign({}, Default, params.settings);
		this.visual = params.visual;

		if (typeof params === 'object')
		{
			this.params = params;
		}

		BX.ready(BX.delegate(this.init,this));
	}

	init()
	{
		this.section = document.getElementById(this.visual.ID);
		this.slider = document.getElementById(this.visual.SLIDER); // document.querySelector('[data-entity="' + this.params.container + '"]');
		this.settings.prevArrow = this.section.querySelector('.prev');
		this.settings.nextArrow = this.section.querySelector('.next');

		$(this.slider).slick(this.settings);
	}
}
